"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashPhone = void 0;
function hashPhone(n) {
    var y = n.split("");
    for (var i = 0; i < y.length; i++) {
        if (i >= 4 && i <= 10) {
            y[i] = "*";
        }
    }
    return y.join("");
}
exports.hashPhone = hashPhone;
